module.exports = __webpack_public_path__ + "static/media/logo.5d045af8.png";